<template>
  <Tabulator
    class="tabulator--entityTabulator"
  />
</template>
<script setup>
defineEmits(['tabulator:created']);
import Tabulator from "@root/components/Tabulator/Tabulator.vue";
</script>
